// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_7vhvi","efficiency-banner":"efficiency-banner_5rku6","g-overlay":"g-overlay","header":"header_uJQH2","g-desc":"g-desc"};